<template>
    <div class="flex justify-between items-center">
        <div>
            <h1 class="my-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
                {{ project.title }}
            </h1>
            <h2 class="mb-2 text-md font-medium leading-7 text-gray-500 sm:truncate">
                <span v-if="project.starts_at !== null">{{
                        moment(project.starts_at, 'YYYY-MM-DD').format('dddd Do MMMM YYYY')
                    }}
                </span></h2>
        </div>
        <div class="text-right text-sm">
            <p><strong>Client:</strong> {{ project.client.name }}</p>
            <p><strong>Project Reference:</strong> {{ project.reference }}</p>
            <p class="flex justify-content-end justify-end">
                <strong class="mr-1">Project Status:</strong>
                <span v-if="project.status === 'Request'"
                      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-gray-500 text-white"> {{
                        project.status
                    }} </span>
                <span v-if="project.status === 'Cost'"
                      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-yellow-100 text-yellow-800"> {{
                        project.status
                    }} </span>
                <span v-if="project.status === 'Cancelled'"
                      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-red-100 text-red-800"> {{
                        project.status
                    }} </span>
                <span v-if="project.status === 'Complete' || project.status === 'Confirmed'"
                      class="inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium shadow-md bg-green-100 text-green-800"> {{
                        project.status
                    }} </span>
            </p>
            <p><strong>Currency:</strong> {{ project.bank_account.currency.code }} | 
                <span v-if="show_currency_code"><strong>Buy Currency:</strong> {{  quote.buy_currency.code }} | </span>
                <strong>Office:</strong> {{ project.office.name }}</p>
                <p><strong>VAT Regime:</strong> {{ project.type.name }} | <strong>Calculation Method:</strong> {{ project.calculation_method }}</p>
        </div>
    </div>
    <div class="flex justify-between">
        <ProjectTabs/>
        <slot name="actions"></slot>
    </div>
</template>


<script>

import ProjectTabs from "@/Components/ProjectTabs";
import moment from "moment/moment";

export default {
    components: {
        ProjectTabs
    },
    props: {
        project: Object,
        quote: Object,
        show_currency_code: Boolean
    },
    created() {
        this.moment = moment
    }
}

</script>
